<template>
  <input v-on="validationListeners"
         :name="name"
         :id="name"
         :type="type"
         :value="inputValue"
         :placeholder="placeholder"
         :autocomplete="autocomplete"
         @blur="handleBlur"
         @keypress="handleKeyPress"
         @keyup.enter="keyupenter"
         ref="inputRef"
  />
  <!--    <FieldInputErrorMessage v-if="displayErrorMsg && errorMessage"-->
  <!--                            :errorMessage="errorMessage"></FieldInputErrorMessage>-->
  <FieldInputErrorMessage v-if="errorMessage"
                          :errorMessage="errorMessage"></FieldInputErrorMessage>
</template>

<script lang="ts">
import {useField} from "vee-validate";
import {computed, defineComponent, ref, toRef, toRefs, watch} from "vue";
import FieldInputErrorMessage from "@/components/UI/FieldInputErrorMessage.vue";

export default defineComponent({
  name: "FieldInput",
  components: {
    FieldInputErrorMessage
  },
  props: {
    type: {
      type: String,
      default: "text",
    },
    required: {
      type: String,
      required: false
    },
    modelValue: {
      type: [String, Number],
    },
    value: {
      type: [String, Number],
    },
    name: {
      type: String,
      required: true,
    },
    autocomplete: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    // displayErrorMsg: {
    //   type: Boolean,
    //   required: false,
    //   default: true,
    // }
  },
  // emits: ["update:modelValue", "errorMessage"],
  emits: ["update:modelValue", "isEnterKeyUp"],
  setup(props, {emit}) {

    const CharacterNotValidPattern = /(\/|\\|\?|¿|>|<|#|\$|\+|%|!|&|\*|\||\{|\}|=|:|@|\(|\))/;
    // const NumberPattern = /^-?\d+$/;

    const inputRef = ref();

    // we don't provide any rules here because we are using form-level validation
    // https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
    // const {name, value} = toRefs(props);
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
    } = useField(toRef(props, "name"), undefined, {
      initialValue: props.value,
      validateOnValueUpdate: false
    });

    watch(inputValue, (val) => {
      // console.log('inputValue. val: ' + JSON.stringify(val) + ' props.type: ' + props.type);
      if (val) {
        const valnumber = Number(val);
        emit("update:modelValue", props.type === 'number' ? val === '-0'
                ? val : (!isNaN(valnumber) ? valnumber : val)
            : val);
        // emit("update:modelValue", val);
      }
      // else if (!val && props.type === 'number' && props.required === 'true') {
      //   console.log('no hay valor y es tipo Number y es obligatorio');
      //   emit("update:modelValue", 0);
      // }
    });

    const validationListeners = computed(() => {
      // If the field is valid or have not been validated yet
      // lazy
      if (!errorMessage.value) {
        return {
          blur: handleChange,
          change: handleChange,
          // disable `shouldValidate` to avoid validating on input
          input: (e: any) => handleChange(e, false),
        };
      }
      // Aggressive
      return {
        blur: handleChange,
        change: handleChange,
        input: handleChange, // only switched this
      };
    });

    // watch(errorMessage, () => {
    //   console.log('watch errormessage: ' + errorMessage.value);
    //   emit("errorMessage", errorMessage.value);
    // });

    const focus = () => {
      inputRef.value.focus();
    }

    const keyupenter = (event: any) => {
      emit("isEnterKeyUp", true);
    };

    const handleKeyPress = (event: any) => {
      if (['text', 'number'].includes(props.type) && CharacterNotValidPattern.test(event.key)) {
        event.preventDefault();
        return false;
      } else {
        // if (props.type === 'number' && !NumberPattern.test(event.key)) {
        //   event.preventDefault();
        //   return false;
        // } else {
        return true;
      }
      // }
    };

    return {
      handleKeyPress,
      keyupenter,
      focus,
      handleChange,
      handleBlur,
      errorMessage,
      inputValue,
      meta,
      validationListeners,
      inputRef
    };
  },
});
</script>

<style scoped>

</style>
